import { RANGE_OPTIONS, type InstanceRange } from "../../../lib/instanceDetailRange";
import styles from "./instanceDetail.module.css";

type RangeControlProps = {
  readonly value: InstanceRange;
  readonly onChange: (next: InstanceRange) => void;
};

// Global 1h/4h/24h/7d/30d selector for the dashboard. The page owns the value
// (deep-linked via ?range=); every time-series panel maps it locally.
export const RangeControl = ({ value, onChange }: RangeControlProps): JSX.Element => (
  <div className={styles.rangePicker} role="group" aria-label="Time range">
    {RANGE_OPTIONS.map((opt) => (
      <button
        key={opt.value}
        type="button"
        className={opt.value === value ? `${styles.rangeBtn} ${styles.rangeBtnActive}` : styles.rangeBtn}
        aria-pressed={opt.value === value}
        onClick={() => onChange(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </div>
);
